export var REWARD_CENTER_ONBOARDING_STEPS = {
  SECOND_VISIT: 'second_visit',
  LINK_ACCOUNT: 'link_account'
};